(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-promo-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-offscreen', !e.isIntersecting); });
    });
    var init = function () { document.querySelectorAll('.bk-promo').forEach(function (el) { io.observe(el); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rack-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rack-rail')) {
    const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
    const smooth = (x) => x * x * (3 - 2 * x);
    const trimCache = new Map();

    // finds the visible garment inside a transparent / white canvas → { t, l, r } as fractions
    const measureTrim = (img) => {
      const src = img.currentSrc || img.src;
      if (trimCache.has(src)) return trimCache.get(src);
      let res = null;
      try {
        const w = 160;
        const h = Math.max(1, Math.round(img.naturalHeight * (w / img.naturalWidth)));
        const c = document.createElement('canvas');
        c.width = w; c.height = h;
        const ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, w, h);
        const d = ctx.getImageData(0, 0, w, h).data;
        let top = h, left = w, right = -1;
        for (let y = 0; y < h; y++) {
          for (let x = 0; x < w; x++) {
            const i = (y * w + x) * 4;
            if (d[i + 3] > 20 && !(d[i] > 244 && d[i + 1] > 244 && d[i + 2] > 244)) {
              if (y < top) top = y;
              if (x < left) left = x;
              if (x > right) right = x;
            }
          }
        }
        if (right > left) {
          const pad = 0.02;
          res = {
            t: clamp(top / h - 0.004, 0, 0.4),
            l: clamp(left / w - pad, 0, 0.45),
            r: clamp((right + 1) / w + pad, 0.55, 1),
          };
        }
      } catch (e) { res = null; } // cross-origin → keep defaults
      trimCache.set(src, res);
      return res;
    };

    class RackRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rk-track]');
        this.caption = this.querySelector('[data-rk-caption]');
        this.defaultCaption = this.caption ? this.caption.textContent : '';
        this.pager = this.querySelector('[data-rk-pager]');
        this.hoverMode = this.dataset.hoverTurn !== 'false';
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.lastPointer = '';
        this.active = null;

        this.items = Array.from(this.querySelectorAll('[data-rk-item]')).map((el) => ({
          el,
          link: el.querySelector('[data-rk-link]'),
          swing: el.querySelector('[data-rk-swing]'),
          tag: el.querySelector('[data-rk-tag]'),
          side: el.querySelector('[data-rk-view="side"]'),
          front: el.querySelector('[data-rk-view="front"]'),
          p: 0, target: 0, ang: 0, vel: 0, wS: 0, wF: 0,
        }));

        this.frame = this.frame.bind(this);
        this.bindPointer();
        this.bindMotion();
        this.bindPager();
        this.bindEditor();
        this.bindTrim();

        this.ro = new ResizeObserver(() => this.layout());
        this.ro.observe(this.track);
        this.layout();
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onDocDown, true);
        window.removeEventListener('scroll', this.onWinScroll);
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      /* ---------------- sizing ---------------- */
      viewWidth(view, h) {
        if (!view) return 0;
        const st = view.style;
        const a = parseFloat(st.getPropertyValue('--a')) || 0.4;
        const t = parseFloat(st.getPropertyValue('--t')) || 0;
        const l = parseFloat(st.getPropertyValue('--l')) || 0;
        const r = parseFloat(st.getPropertyValue('--r')) || 1;
        return (h * a * (r - l)) / (1 - t);
      }

      layout() {
        const cs = getComputedStyle(this);
        const snap = this.snapMode();
        this.snap = snap;
        const base = parseFloat(cs.getPropertyValue(snap ? '--rk-h-m' : '--rk-h-d')) || 400;
        this.fs = parseFloat(cs.getPropertyValue('--rk-fs')) || 1;
        this.h = base;
        let fit = false;
        if (snap) {
          this.style.removeProperty('--rk-h');
        } else {
          // desktop: shrink the garments just enough that the whole rail – incl. one turned
          // garment – fits the width. Nothing ever scrolls on desktop, so nothing can jump.
          const tcs = getComputedStyle(this.track);
          const W = this.track.clientWidth - parseFloat(tcs.paddingLeft) - parseFloat(tcs.paddingRight);
          const gap = parseFloat(tcs.columnGap) || 0;
          let sum = 0, maxDelta = 0;
          this.items.forEach((it) => {
            const sF = this.viewWidth(it.side, 1);
            const fF = it.front ? this.viewWidth(it.front, this.fs) : sF;
            sum += sF;
            maxDelta = Math.max(maxDelta, fF - sF);
          });
          if (sum > 0 && W > 0) {
            const hFit = (W - gap * (this.items.length - 1) - 4) / (sum + maxDelta);
            this.h = Math.min(base, Math.max(200, hFit));
            fit = hFit >= 200;
          }
          this.style.setProperty('--rk-h', this.h.toFixed(1) + 'px');
        }
        this.fit = fit;
        this.classList.toggle('rk--fit', fit);
        this.items.forEach((it) => {
          it.wS = this.viewWidth(it.side, this.h);
          it.wF = it.front ? this.viewWidth(it.front, this.h * this.fs) : it.wS;
          this.paint(it);
        });
        this.applyOffsets();
        this.classList.toggle('is-scrollable', this.track.scrollWidth > this.track.clientWidth + 2);
        this.syncPager();
      }

      // mobile: the boxes never change size (no reflow, scroll-snap stays put) – the turned garment
      // grows visually and its neighbours slide aside with a cheap transform instead
      applyOffsets() {
        const n = this.items.length;
        const offs = new Array(n).fill(0);
        if (this.snap) {
          this.items.forEach((it, i) => {
            const e = smooth(it.p);
            if (e <= 0.001) return;
            const d = ((it.wF - it.wS) / 2 + 6) * e;
            for (let j = 0; j < n; j++) {
              if (j < i) offs[j] -= d;
              else if (j > i) offs[j] += d;
            }
          });
        }
        this.items.forEach((it, j) => {
          it.off = offs[j];
          it.el.style.transform = offs[j] ? `translate3d(${offs[j].toFixed(2)}px,0,0)` : '';
        });
      }

      bindTrim() {
        if (this.dataset.autoTrim === 'false') return;
        let queued = false;
        const relayout = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => { queued = false; this.layout(); });
        };
        this.querySelectorAll('[data-rk-view] img').forEach((img) => {
          const apply = () => {
            const tr = measureTrim(img);
            if (!tr) return;
            const v = img.closest('[data-rk-view]');
            v.style.setProperty('--t', tr.t.toFixed(4));
            v.style.setProperty('--l', tr.l.toFixed(4));
            v.style.setProperty('--r', tr.r.toFixed(4));
            relayout();
          };
          if (img.complete && img.naturalWidth) apply();
          else img.addEventListener('load', apply, { once: true });
        });
        // front images are lazy and off-screen-ish: warm them up once the rail is near
        this.querySelectorAll('[data-rk-view="front"] img').forEach((img) => { img.loading = 'eager'; });
      }

      /* ---------------- paint one garment ---------------- */
      paint(it) {
        const e = smooth(it.p);
        // width grows with the turn so neighbours glide aside
        it.el.style.width = (this.snap ? it.wS : it.wS + (it.wF - it.wS) * e).toFixed(2) + 'px';

        if (it.front) {
          // continuous cross-blend: the front fades in on top while the side is still fully there,
          // so the garment never disappears – it reads as one piece turning towards you
          const fIn = smooth(clamp((e - 0.12) / 0.55, 0, 1));
          const sOut = smooth(clamp((e - 0.45) / 0.45, 0, 1));
          const sAng = -38 * e;                // side rotates towards the viewer
          const fAng = 26 * (1 - e);           // front arrives from a slight angle
          const sSq = 1 - 0.1 * e;
          const fSc = 0.9 + 0.1 * e;
          it.side.style.opacity = (1 - sOut).toFixed(3);
          it.side.style.transform = e > 0.001 ? `perspective(1100px) rotateY(${sAng.toFixed(2)}deg) scaleX(${sSq.toFixed(4)})` : '';
          it.front.style.opacity = fIn.toFixed(3);
          it.front.style.transform = e < 0.999 ? `perspective(1100px) rotateY(${fAng.toFixed(2)}deg) scale(${fSc.toFixed(4)})` : '';
        }
        if (it.tag) {
          const tx = -50, rot = -2.5 * (1 - e);
          it.tag.style.transform = `translateX(${tx.toFixed(2)}%) rotate(${rot.toFixed(2)}deg)`;
        }
        it.swing.style.transform = it.ang ? `rotate(${(-it.ang).toFixed(3)}deg)` : '';
      }

      /* ---------------- one loop: turn progress + swing physics ---------------- */
      start() {
        if (!this.raf) { this.last = performance.now(); this.raf = requestAnimationFrame(this.frame); }
      }

      frame(now) {
        const dtMs = Math.min(48, now - this.last);
        this.last = now;
        const dt = dtMs / 16.67;
        const kTurn = this.reduced ? 1 : 1 - Math.exp(-dtMs / 150);
        const k = 0.045, damp = Math.pow(0.915, dt);
        let busy = false, widthMoved = false;

        this.items.forEach((it) => {
          const d = it.target - it.p;
          if (Math.abs(d) > 0.001) { it.p += d * kTurn; busy = true; widthMoved = true; }
          else if (it.p !== it.target) { it.p = it.target; widthMoved = true; }

          if (!this.reduced) {
            it.vel += -k * it.ang * dt;
            it.vel *= damp;
            it.ang += it.vel * dt;
            if (it.ang > 6) { it.ang = 6; it.vel *= -0.4; }
            if (it.ang < -6) { it.ang = -6; it.vel *= -0.4; }
            if (Math.abs(it.ang) > 0.02 || Math.abs(it.vel) > 0.02) busy = true;
            else { it.ang = 0; it.vel = 0; }
          }
          this.paint(it);
        });

        if (widthMoved) {
          this.applyOffsets();
          if (this.follow && !this.snap) this.centerOn(this.follow, 'auto');
          if (!this.snap) this.classList.toggle('is-scrollable', this.track.scrollWidth > this.track.clientWidth + 2);
          this.syncPager();
        }
        if (this.anchor) busy = this.runAnchor(dtMs) || busy;
        if (busy) this.raf = requestAnimationFrame(this.frame);
        else { this.raf = 0; this.follow = null; }
      }

      /* mobile scroll anchor: keeps the rail still while garments open/close, and glides the
         tapped garment to the centre in step with its turn – no fighting with scroll-snap */
      setAnchor(it, mode) {
        if (!this.snap || !it) return;
        const r = it.el.getBoundingClientRect();
        this.anchor = { it, mode, x: (r.left + r.right) / 2, off: it.off || 0 };
        this.track.style.scrollSnapType = 'none';
        this.start();
      }

      clearAnchor() {
        if (!this.anchor) return;
        this.anchor = null;
        this.track.style.scrollSnapType = '';
      }

      runAnchor(dtMs) {
        const a = this.anchor, t = this.track;
        // neighbours opening/closing shift this garment – cancel that instantly so it never jumps
        const offNow = a.it.off || 0;
        if (offNow !== a.off) { t.scrollLeft += offNow - a.off; a.off = offNow; }
        const r = a.it.el.getBoundingClientRect();
        const c = (r.left + r.right) / 2;
        const tr = t.getBoundingClientRect();
        const goal = a.mode === 'center' ? tr.left + t.clientWidth / 2 : a.x;
        const diff = c - goal;
        const k = a.mode === 'center' ? 1 - Math.exp(-dtMs / 110) : 1;
        const before = t.scrollLeft;
        if (Math.abs(diff) > 0.5) t.scrollLeft += diff * k;
        const stuck = Math.abs(t.scrollLeft - before) < 0.1;   // reached an edge / sub-pixel
        const turning = this.items.some((it) => Math.abs(it.target - it.p) > 0.001);
        if (!turning && (Math.abs(diff) <= 1 || stuck)) { this.clearAnchor(); return false; }
        return true;
      }

      kick(it, impulse) {
        if (this.reduced || !it) return;
        it.vel = clamp(it.vel + impulse, -2.2, 2.2);
        this.start();
      }

      ripple(i, strength) {
        for (let d = 1; d <= 3; d++) {
          const f = (1.1 / d) * strength;
          this.kick(this.items[i - d], -f);
          this.kick(this.items[i + d], f);
        }
      }

      /* ---------------- active garment ---------------- */
      setActive(it, opts = {}) {
        if (it === this.active) return;
        const prev = this.active;
        this.active = it;
        if (prev) { prev.target = 0; prev.el.classList.remove('is-active'); }
        if (it) {
          it.target = 1;
          it.el.classList.add('is-active');
          this.ripple(this.items.indexOf(it), 1);
          if (this.caption) this.caption.textContent = it.el.dataset.title;
          if (opts.center) this.follow = it;
        } else {
          if (prev) this.ripple(this.items.indexOf(prev), -0.5);
          if (this.caption) this.caption.textContent = this.defaultCaption;
        }
        this.start();
      }

      isTouch() {
        if (this.lastPointer) return this.lastPointer !== 'mouse';
        return !this.finePointer.matches;
      }

      bindPointer() {
        this.track.addEventListener('pointerdown', (e) => { this.lastPointer = e.pointerType || ''; }, true);

        // touch: a tap = finger down + up without moving. The finger takes over the scroll from us.
        let tap = null;
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse') return;
          this.clearAnchor();
          tap = { x: e.clientX, y: e.clientY, t: performance.now() };
        });
        this.track.addEventListener('pointermove', (e) => {
          if (tap && (Math.abs(e.clientX - tap.x) > 8 || Math.abs(e.clientY - tap.y) > 8)) tap = null;
        });
        this.track.addEventListener('pointercancel', () => { tap = null; });
        this.track.addEventListener('pointerup', (e) => {
          if (!tap || e.pointerType === 'mouse') return;
          const ok = performance.now() - tap.t < 500;
          tap = null;
          if (!ok) return;
          this.tapAt = performance.now();
          this.handleTap(e.clientX);
        });

        // touch: tap outside the rail turns the garment back
        this.onDocDown = (e) => {
          if (!this.active || e.pointerType === 'mouse') return;
          if (!this.track.contains(e.target) && !this.pager.contains(e.target)) this.setActive(null);
        };
        document.addEventListener('pointerdown', this.onDocDown, true);

        this.items.forEach((it) => {
          it.link.addEventListener('click', (e) => {
            if (!this.isTouch() && this.hoverMode) return;   // desktop: click → product page
            e.preventDefault();
            if (performance.now() - (this.tapAt || 0) < 700) return;   // already handled on pointerup
            this.handleTap(e.detail ? e.clientX : null, it);
          });
          it.link.addEventListener('focus', () => {
            if (it.link.matches(':focus-visible')) this.setActive(it, { center: this.snapMode() });
          });
        });

        // desktop hover with hysteresis (the hovered garment widens, so we keep it while the cursor is near)
        this.track.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse' || !this.hoverMode) return;
          const x = e.clientX;
          if (this.active) {
            const r = this.active.el.getBoundingClientRect();
            if (x >= r.left - 16 && x <= r.right + 16) { clearTimeout(this.hoverT); this.pendingHover = null; return; }
          }
          let best = null, bd = Infinity;
          this.items.forEach((it) => {
            const r = it.el.getBoundingClientRect();
            if (x < r.left || x > r.right) return;
            const dd = Math.abs(x - (r.left + r.right) / 2);
            if (dd < bd) { bd = dd; best = it; }
          });
          if (!best || best === this.pendingHover) return;
          this.pendingHover = best;
          clearTimeout(this.hoverT);
          this.hoverT = setTimeout(() => { this.pendingHover = null; this.setActive(best); }, this.active ? 90 : 40);
        });
        this.track.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse' || !this.hoverMode) return;
          clearTimeout(this.hoverT); this.pendingHover = null;
          this.setActive(null);
        });
      }

      /* ---------------- ambient motion ---------------- */
      bindMotion() {
        let lastX = this.track.scrollLeft, settle;
        this.track.addEventListener('scroll', () => {
          const x = this.track.scrollLeft;
          const dx = x - lastX; lastX = x;
          if (!this.reduced) {
            const imp = clamp(dx * 0.025, -0.5, 0.5);
            this.items.forEach((it) => this.kick(it, imp * (0.75 + Math.random() * 0.5)));
          }
          this.syncPager();
          // touch: swiping the turned garment away from the centre turns it back
          clearTimeout(settle);
          settle = setTimeout(() => {
            if (!this.active || !this.isTouch() || this.follow || this.anchor || performance.now() < (this.lock || 0)) return;
            const t = this.track, tr = t.getBoundingClientRect();
            const r = this.active.el.getBoundingClientRect();
            const off = Math.abs((r.left + r.right) / 2 - (tr.left + t.clientWidth / 2));
            if (off > Math.max(60, this.active.wS)) {
              this.setAnchor(this.nearest(), 'keep');
              this.setActive(null);
            }
          }, 220);
        }, { passive: true });

        if (this.reduced) return;

        let lastY = window.scrollY;
        this.onWinScroll = () => {
          const y = window.scrollY; const dy = y - lastY; lastY = y;
          if (!this.inView) return;
          const imp = clamp(dy * 0.004, -0.18, 0.18);
          this.items.forEach((it, i) => this.kick(it, imp * (i % 2 ? 1 : -0.8) * (0.7 + Math.random() * 0.6)));
        };
        window.addEventListener('scroll', this.onWinScroll, { passive: true });

        let px = null, pt = 0;
        this.track.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse') return;
          const now = performance.now();
          if (px !== null && now - pt < 80) {
            const vx = ((e.clientX - px) / Math.max(1, now - pt)) * 16;
            this.items.forEach((it) => {
              if (it === this.active) return;
              const r = it.el.getBoundingClientRect();
              const c = (r.left + r.right) / 2;
              if ((px - c) * (e.clientX - c) < 0) this.kick(it, clamp(vx * 0.035, -0.6, 0.6));
            });
          }
          px = e.clientX; pt = now;
        });
        this.track.addEventListener('pointerleave', () => { px = null; });

        this.io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            this.inView = en.isIntersecting;
            if (en.isIntersecting && !this.entered) {
              this.entered = true;
              this.items.forEach((it, i) => setTimeout(() => this.kick(it, (i % 2 ? 1 : -1) * (0.6 + Math.random() * 0.4)), i * 70));
            }
          });
        }, { threshold: 0.25 });
        this.io.observe(this);
      }

      // touch tap: 1st tap on a garment turns it (and glides it to the centre), 2nd tap opens it
      handleTap(x, fallback) {
        const target = (x != null && this.pickAt(x)) || fallback;
        if (!target) return;
        if (this.active === target) { window.location.href = target.link.href; return; }
        this.lock = performance.now() + 900;
        this.setActive(target);
        if (this.snap) this.setAnchor(target, 'center');
        else if (!this.fit && this.track.scrollWidth > this.track.clientWidth + 2) this.follow = target;
      }

      // the garment that is visually under x (uses the drawn garment, not the link box)
      pickAt(x) {
        if (this.active) {
          const v = this.active.front || this.active.side;
          const r = v.getBoundingClientRect();
          if (x >= r.left && x <= r.right) return this.active;
        }
        let best = null, bd = Infinity;
        this.items.forEach((it) => {
          const r = it.side.getBoundingClientRect();
          const c = (r.left + r.right) / 2;
          const inside = x >= r.left && x <= r.right;
          const d = Math.abs(x - c) - (inside ? 1e4 : 0);
          if (d < bd) { bd = d; best = it; }
        });
        return best;
      }

      /* ---------------- scrolling + pager ---------------- */
      nearest() {
        const t = this.track;
        const mid = t.getBoundingClientRect().left + t.clientWidth / 2;
        let best = null, bd = Infinity;
        this.items.forEach((it) => {
          const r = it.el.getBoundingClientRect();
          const d = Math.abs((r.left + r.right) / 2 - mid);
          if (d < bd) { bd = d; best = it; }
        });
        return best;
      }

      centerOn(it, behavior) {
        const t = this.track;
        const tr = t.getBoundingClientRect(), r = it.el.getBoundingClientRect();
        const left = t.scrollLeft + (r.left + r.width / 2) - (tr.left + t.clientWidth / 2);
        t.scrollTo({ left, behavior: behavior || 'smooth' });
      }

      // mobile layout (matches the 749px breakpoint in the stylesheet) – not read from the computed
      // scroll-snap, because the anchor switches snapping off while it glides
      snapMode() {
        if (!this.mq) this.mq = window.matchMedia('(max-width: 749px)');
        return this.mq.matches;
      }

      // which garment the dots should show as current
      // desktop: only the turned (selected) garment; nothing selected → no current dot
      // mobile: the selected garment, otherwise the one in the centre
      currentIndex() {
        if (this.dotTarget != null) return this.dotTarget;
        if (this.active) return this.items.indexOf(this.active);
        if (this.snapMode()) return this.items.indexOf(this.nearest());
        return -1;
      }

      syncPager() {
        if (!this.dots || !this.dots.length) return;
        const cur = this.currentIndex();
        this.dots.forEach((d, i) => d.classList.toggle('is-current', i === cur));
      }

      // dot → mobile: just scrolls the garment to the centre (stays side-on);
      //        desktop: turns that garment to the front (centred too if the rail scrolls)
      goTo(i, smoothScroll) {
        const it = this.items[i];
        if (!it) return;
        const scrollable = !this.fit && this.track.scrollWidth > this.track.clientWidth + 2;
        if (this.isTouch()) {
          if (this.active && this.active !== it) this.setActive(null);
          this.dotTarget = i;
          clearTimeout(this.dotT);
          this.dotT = setTimeout(() => { this.dotTarget = null; this.syncPager(); }, smoothScroll ? 700 : 150);
          if (smoothScroll) this.setAnchor(it, 'center');
          else { this.clearAnchor(); this.centerOn(it, 'auto'); }
        } else {
          // desktop: just turn it; only scroll if it is (rarely) out of view
          this.setActive(it);
          if (scrollable) {
            clearTimeout(this.recenterT);
            this.recenterT = setTimeout(() => {
              if (this.active !== it) return;
              const tr = this.track.getBoundingClientRect(), r = it.el.getBoundingClientRect();
              if (r.left < tr.left || r.right > tr.right) this.centerOn(it, 'smooth');
            }, 480);
          }
        }
        this.syncPager();
      }

      bindPager() {
        if (!this.pager) return;
        this.dots = Array.from(this.pager.querySelectorAll('[data-rk-dot]'));
        let drag = false, startX = 0, moved = false, lastIdx = -1;
        const dotAt = (clientX) => {
          let best = -1, bd = Infinity;
          this.dots.forEach((d, i) => {
            const r = d.getBoundingClientRect();
            const dd = Math.abs(clientX - (r.left + r.right) / 2);
            if (dd < bd) { bd = dd; best = i; }
          });
          return best;
        };
        this.pager.addEventListener('pointerdown', (e) => {
          this.lastPointer = e.pointerType || this.lastPointer;
          drag = true; moved = false; startX = e.clientX; lastIdx = dotAt(e.clientX);
          try { this.pager.setPointerCapture(e.pointerId); } catch (err) {}
          e.preventDefault();
        });
        this.pager.addEventListener('pointermove', (e) => {
          if (!drag) return;
          if (Math.abs(e.clientX - startX) > 6) moved = true;
          if (!moved) return;
          const i = dotAt(e.clientX);
          if (i > -1 && i !== lastIdx) { lastIdx = i; this.goTo(i, false); }
        });
        const end = (e) => {
          if (!drag) return;
          drag = false;
          if (!moved && e.type === 'pointerup') this.goTo(dotAt(e.clientX), true);
        };
        this.pager.addEventListener('pointerup', end);
        this.pager.addEventListener('pointercancel', end);
      }

      /* ---------------- theme editor ---------------- */
      bindEditor() {
        if (!window.Shopify || !window.Shopify.designMode) return;
        document.addEventListener('shopify:block:select', (e) => {
          const it = this.items.find((x) => x.el.dataset.blockId === (e.detail && e.detail.blockId));
          if (it) this.setActive(it, { center: this.snapMode() });
        });
        document.addEventListener('shopify:block:deselect', () => this.setActive(null));
      }
    }
    customElements.define('rack-rail', RackRail);
  }

  } catch(e) { console.error(e); }
})();
})();
